






















































































































































































































































































































































































































import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import { TypeformForm } from '@/api/model/typeform/typeform-form'
import { TypeformFieldUnion, TypeformField } from '@/api/model/typeform/typeform-field'
import { TypeformWelcomeScreen } from '@/api/model/typeform/typeform-welcome-screen'
import { TypeformThankYouScreen } from '@/api/model/typeform/typeform-thank-you-screen'
import { TypeformMap } from '@/api/model/typeform/typeform-map'
import InputFieldType from '@/views/Company/Settings/Typeform/Forms/Detail/InputFieldType.vue'
import InputFieldTypeSelect from '@/views/Company/Settings/Typeform/Forms/Detail/InputFieldTypeSelect.vue'
import InputTextarea from '@/components/input/InputTextarea.vue'
import { v4 as uuid } from 'uuid'
import { cloneDeep } from 'lodash'

@Component({
    components: {
        InputFieldType,
        InputFieldTypeSelect,
    },
})
export default class TypeformPopOut extends Vue {
    @Prop({ required: true }) readonly form!: TypeformForm
    @Prop({ required: true }) readonly field!: TypeformFieldUnion
    @Prop({ required: true, default: false }) readonly show!: boolean
    showPopOut: boolean = false
    @Prop({ default: true }) readonly editing!: boolean
    editingType: boolean = false
    internalField: TypeformFieldUnion = null
    @Ref() titleInput: InputTextarea
    @Ref() descriptionInput: InputTextarea

    @Watch('show')
    onShowChanged() {
        this.showPopOut = this.show
    }

    @Watch('showPopOut')
    onShowPopOutChanged() {
        if (!this.showPopOut) {
            this.$emit('closed')
        }
    }

    @Watch('field', { immediate: true })
    onFieldChanged() {
        this.internalField = cloneDeep(this.field)

        this.editingType = false
        if (this.internalField instanceof TypeformField && !this.internalField.type) {
            this.editingType = true
        }
    }

    onRedirectUrlChanged(redirectUrl) {
        if (!this.hasTitle) {
            this.internalField.title = redirectUrl
        }
    }

    save(closeModal: () => void): void {
        this.$emit('save', this.internalField)
        closeModal()
    }

    get fieldType(): string {
        if (this.internalField instanceof TypeformField) {
            return 'fields'
        }

        if (this.internalField instanceof TypeformWelcomeScreen) {
            return 'welcome_screens'
        }

        if (this.internalField instanceof TypeformThankYouScreen) {
            return 'thankyou_screens'
        }

        return null
    }

    insertReference(field: string, fieldInput: InputTextarea, reference): void {
        if (!reference) {
            return
        }

        const textarea = fieldInput.$refs.element as HTMLTextAreaElement
        if (!textarea) {
            return
        }

        const selectionStart = textarea.selectionStart
        const selectionEnd = textarea.selectionEnd

        let value = this.internalField[field]
        value = value.substring(0, selectionStart) + reference + value.substring(selectionEnd)
        this.internalField[field] = value
    }

    get insertReferenceOptions() {
        return this.field.getAllowedReferenceOptions(this.form, (type, value) => `{{${type}:${value}}}`)
    }

    get hasTitle(): boolean {
        return this.internalField.type !== 'url_redirect'
    }

    hasProperty(property: string): boolean {
        return property in this.internalField.properties
    }

    hasRedirectUrlProperty(): boolean {
        // Check if property exists
        if (!this.hasProperty('redirect_url')) {
            return false
        }

        // Check if property should exist
        if (this.internalField.type === 'url_redirect') {
            return true
        }

        if (this.hasProperty('button_mode') && this.internalField.properties.button_mode === 'redirect') {
            return true
        }

        return false
    }

    hasValidation(validation: string): boolean {
        if (this.internalField instanceof TypeformField) {
            return validation in this.internalField.validations
        }

        return false
    }

    get attachment(): TypeformMap|null {
        if (this.internalField.layout && 'attachment' in this.internalField.layout) {
            return this.internalField.layout.attachment as TypeformMap
        }

        if (this.internalField.attachment) {
            return this.internalField.attachment
        }

        return null
    }

    get layout(): string {
        if (this.internalField.layout) {
            const type = 'type' in this.internalField.layout ? this.internalField.layout.type as string : null
            let placement = 'placement' in this.internalField.layout ? this.internalField.layout.placement as string : null

            if (type === 'float' || type === 'split') {
                placement = placement || 'right'
            }

            if (type && placement) {
                return type + '-' + placement
            } else if (type) {
                return type
            }
        }

        return 'stack'
    }

    set layout(layout: string) {
        const attachment = this.attachment
        let type = null
        let placement = null

        if (layout !== 'stack') {
            [type, placement] = layout.split('-')
        }

        if (type && placement) {
            this.internalField.layout = { type, placement, attachment }
        } else if (type) {
            this.internalField.layout = { type, attachment }
        } else {
            this.internalField.layout = null
        }

        this.internalField.attachment = cloneDeep(attachment)
        this.internalField.attachment.properties = {
            description: (this.internalField.attachment.properties as TypeformMap).description,
        }
    }

    get layoutOptions() {
        const layouts = [
            'stack',
            'float-right',
            'float-left',
            'split-right',
            'split-left',
            'wallpaper',
        ]

        return layouts.map(layout => ({
            label: this.$t(`company_settings.typeform_forms.layout_options.${layout}`).toString(),
            value: layout,
        }))
    }

    get yesNoOptions() {
        return [
            { label: this.$t('yes'), value: true },
            { label: this.$t('no'), value: false },
        ]
    }

    get buttonModeOptions() {
        const buttonModes = [
            'default_redirect',
            'redirect',
        ]

        return buttonModes.map(buttonMode => ({
            label: buttonMode,
            value: buttonMode,
        }))
    }

    choiceDefaultValue() {
        return {
            label: '',
            ref: uuid(),
        }
    }

    get currencyOptions() {
        const currencyCodes = [
            'AUD',
            'BRL',
            'CAD',
            'CHF',
            'DKK',
            'EUR',
            'GBP',
            'MXN',
            'NOK',
            'SEK',
            'USD',
        ]

        return currencyCodes.map(currencyCode => ({
            label: currencyCode,
            value: currencyCode,
        }))
    }

    get separatorOptions() {
        const separators = [
            '/',
            '-',
            '.',
        ]

        return separators.map(separator => ({
            label: separator,
            value: separator,
        }))
    }

    get shapeOptions() {
        const shapes = [
            'cat',
            'circle',
            'cloud',
            'crown',
            'dog',
            'droplet',
            'flag',
            'heart',
            'lightbulb',
            'pencil',
            'skull',
            'star',
            'thunderbolt',
            'tick',
            'trophy',
            'up',
            'user',
        ]

        return shapes.map(shape => ({
            label: shape,
            value: shape,
        }))
    }

    get structureOptions() {
        const structures = [
            'MMDDYYYY',
            'DDMMYYYY',
            'YYYYMMDD',
        ]

        return structures.map(structure => ({
            label: structure,
            value: structure,
        }))
    }
}
